addEventListener('DOMContentLoaded', () => {
	const renderedForms = document.body.querySelectorAll('.form-holder form')
	renderedForms.forEach(initializeForm)
})

function initializeForm (form) {
	const submitButton = form.querySelector('button[type=submit]')
	const messageBox = form.querySelector('.submitted-message')

	//
	// Fetch request for submitting.
	const submitForm = (extraValues = {}) => {
		form.classList.add('busy')
		submitButton.disabled = true

		// Submit the data to the gateway.
		const path = form.getAttribute('action')
		const formData = new FormData(form)
		for (const [key, value] of Object.entries(extraValues)) {
			formData.append(key, value)
		}

		fetch(path, {
			body: formData,
			method: 'post'
		})
			.then(response => response.json())
			.then(json => {
				if (json.status === true) {
					form.classList.add('success')
					messageBox?.scrollIntoView?.({
						behavior: 'smooth'
					})
				}
				else {
					submitButton.disabled = false
					form.classList.remove('busy')
					alert(localized.form.invalidValues)
				}
			})
			.catch(error => {
				form.classList.remove('busy')
				submitButton.disabled = false
				console.error(error)
				alert(localized.form.unknownError)
			})
	}

	//
	// Catch submit event.
	form.addEventListener('submit', (event) => {
		event.preventDefault()

		if (!validateForm()) {
			return
		}

		// Check whether a captcha key is present.
		// If it is, the form should only be sent after captcha validation.
		const captchaKey = form.dataset.recaptchaKey

		if (captchaKey) {
			grecaptcha.ready(function () {
				grecaptcha.execute(captchaKey, { action: 'submit' })
					.then(function (token) {
						submitForm({
							'g-recaptcha-response': token
						})
					})
					// Captcha fail.
					.catch(function (error) {
						form.classList.add('error')
						console.warn('Captcha error:')
						console.error(error)
					})
			})
		}
		else {
			submitForm()
		}
	})

	//
	// Validation of inputs.
	const inputs = form.querySelectorAll('input, select, textarea')

	const validateForm = () => {
		let valid = true

		for (let a = 0; a < inputs.length; a++) {
			const input = inputs[a]
			if (input.required || input.parentNode.classList.contains('required')) {
				if ((input.type == 'checkbox' && !input.checked)
					|| (input.type != 'file' && input.value.trim() == '')
					|| (input.type == 'file' && input.files.length == 0)
				) {
					valid = false
					break
				}
			}
		}

		submitButton.disabled = !valid
		return valid
	}

	for (let a = 0; a < inputs.length; a++) {
		const input = inputs[a]

		if (input.required || input.parentNode.classList.contains('required')) {
			input.addEventListener('blur', function (event) {
				validateForm()

				const valid = this.value.trim() != ''
				this.parentNode.classList[valid ? 'remove' : 'add']('invalid')
			})
		}

		input.addEventListener('change', validateForm)
		input.addEventListener('input', validateForm)

		// Add filesize cap for file select.
		if (input.type == 'file') {
			input.addEventListener('change', function (event) {
				if (this.files.length > 0) {
					const mb = 8
					const MAX_SIZE = mb * 1024 * 1024

					if (this.files[0].size > MAX_SIZE) {
						alert(localized.form.limitedFileSize.replace('{$1}', mb))
						this.value = ''
					}
				}
			})
		}

		input.addEventListener('focus', function () {
			this.parentNode.classList.add('focus')
		})

		input.addEventListener('blur', function () {
			this.parentNode.classList.remove('focus')
		})
	}

	validateForm()
}